import React from 'react'
import './assets/main.scss'
import "wired-elements";

import Homepage from './views/Homepage'

const App = () => {
  return (
      <div className="App ui container">
        <Homepage/>
      </div>
  );

}

export default App;

